<template>
  <div class="description-text">
    {{ content[0] }}
    <div class="category-text" v-if="displayCategoryName"
    >{{ lowerCaseCategory }} category</div>{{ content[1] || '' }}
  </div>
</template>

<script>

export default {
  data() {
    return {
      brandViewContent: [
        'Compare your brand’s performance across different time periods to ' +
        'see how you’re progressing towards your goals. ' +
        'Select your comparison date ranges above to get started.',
      ],
      categoryViewContent: [
        'Category benchmarking offers competitive insight into businesses in the ',
        '. All category benchmarks are viewed on a per quarter basis.',
      ],
    };
  },
  props: {
    view: String,
    category: {
      type: String,
      default: '',
    },
  },
  computed: {
    displayCategoryName() {
      return this.view === 'category';
    },
    content() {
      return this.view === 'brand'
        ? this.brandViewContent
        : this.categoryViewContent;
    },
    lowerCaseCategory() {
      return this.category.toLowerCase().replaceAll('_', ' ');
    },
  },
};
</script>

<style scoped>
.description-text {
  font-size: 16px;
  font-weight: 400;
  font-family: Lato;
  color: #778699;
  text-align: left;
}

.category-text {
  display: inline;
  font-weight: bold;
  text-decoration: underline;
}
</style>
